package model

import kotlinx.serialization.Serializable

@Serializable
data class MerchantFullInformationV3(
    val consumerLoyaltyProgramGuid: String? = "",
    val loyaltyProgramId: Int? = -1,
    val enrollMerchantId: Int? = -1,
    val enrollLocationId: Int? = -1,
    val pointBalanceCurrent: Double? = 0.0,
    val rewardBalanceCurrent: Double? = 0.0,
    val consumerId: Int? = -1,
    val merchantId: Int? = -1,
    val name: String? = "",
    val phoneNumber: Long? = -1,
    val address: String? = "",
    var points: Points? = null,
    val optInType: Int? = -1,
    val shouldDisplayAdminDemoCards: Boolean? = false,
    // Nearest other Near Me store within NEAR_ME_RADIUS_METERS of the enroll location, null when there is none
    // or it can't be measured. Older apps ignore this field
    val distanceToNearestStoreMeters: Double? = null,
)